import { render, staticRenderFns } from "./generalsettings.vue?vue&type=template&id=7dd27210&scoped=true&"
import script from "./generalsettings.vue?vue&type=script&lang=js&"
export * from "./generalsettings.vue?vue&type=script&lang=js&"
import style0 from "./generalsettings.vue?vue&type=style&index=0&id=7dd27210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd27210",
  null
  
)

export default component.exports